/** @format */

import { ActionUtils } from '../action';
import { orgFindTreeDataByAll as findTreeDataByAll } from '@/api/position/index';
export default {
	methods: {
		// 查询全部-1
		findTreeDataByAll(paramsOptions) {
			const params = {};
			// 范围选择器调用
			params.orgId = paramsOptions.node.level === 0 ? null : paramsOptions.node.data.id;
			return new Promise((resolve) => {
				findTreeDataByAll(ActionUtils.formatParams(params)).then((res) => {
					resolve(res);
				});
			});
		},
		// 查询当前-2
		// findTreeDataByTheOrg(paramsOptions) {
		// 	const params = this.conformityParams(paramsOptions);
		// 	return new Promise((resolve) => {
		// 		findTreeDataByTheOrg(params).then((res) => {
		// 			resolve(res.data);
		// 		});
		// 	});
		// },
		// 查询指定-3
		// findTreeDataByOrg(paramsOptions) {
		// 	const params = this.conformityParams(paramsOptions);
		// 	return new Promise((resolve) => {
		// 		findTreeDataByOrg(params).then((res) => {
		// 			resolve(res.data);
		// 		});
		// 	});
		// },
		// conformityParams(paramsOptions) {
		// 	const params = {};
		// 	const type = this.partyTypeId;
		// 	const check =
		// 		this.$utils.isNotEmpty(this.currentOrgId) &&
		// 		paramsOptions.node.data &&
		// 		paramsOptions.node.data.id === '0' &&
		// 		!this.$store.getters.isSuper;
		// 	if (this.isUseScope) {
		// 		// 范围选择器调用
		// 		params.includeSub = paramsOptions.hasSubset;
		// 		if (paramsOptions.node.data && paramsOptions.node.data.id !== '0') {
		// 			params.orgId = paramsOptions.node.level === 0 ? null : check ? this.currentOrgId : paramsOptions.node.data.id;
		// 		}
		// 		if (type === '2') {
		// 			if (this.$utils.isNotEmpty(paramsOptions.node.data) && paramsOptions.node.data.id !== '0') {
		// 				params.type = '1';
		// 			}
		// 		} else {
		// 			if (this.$utils.isEmpty(paramsOptions.node.data) || paramsOptions.node.data.id === '0') {
		// 				params.partyId = this.currentOrgId;
		// 			}
		// 		}
		// 	} else {
		// 		// 普通模式
		// 		params.orgId = paramsOptions.node.level === 0 ? null : paramsOptions.node.data.id;
		// 	}
		// 	return params;
		// },
	},
};
